/*
 * @Author: liyxt
 * @Date: 2019-10-14 11:19:57
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-02 10:18:17
 * @Description: file content
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from '../DatePicker';
import {
	getDateFunNode,
	getFuntionValue,
	getTimeFunctionLabel,
	setMultiLang,
	timeFunctionHandler,
} from './dateFunction';
import { DongbaToLocalTime, LocalToDongbaTime, isDongba, localeLang } from '@platform/api';
import RangePicker from '../RangePicker';
import { getMultiLang } from '@platform/api';
import { isArrowKeyDown, isIE, setElementFocusInIE } from '@platform/api';

require('bee-datepicker/build/DatePicker.css');
require('./index.less');

let localeZoneIsDongba = isDongba();

class DatePickerClientS extends Component {
	constructor(props) {
		super(props);
		this.opened = false;
		this.state = { current: '', localeLang: 'simpchn', json: {}, timeFun: null };
	}

	componentWillMount() {
		let callback = json => {
			setMultiLang(json);
			this.setState({ json, localeLang }, () => {
				window.addEventListener('mousedown', this.close, false);

				this.getDefaultTime(this.props);
			});
		};
		getMultiLang({ moduleId: 'page_search', callback });
	}

	componentWillUnmount() {
		// 移除document事件
		window.removeEventListener('mousedown', this.close);
		this.select = null;
		this.datepickerWrap = null;

		this.outInput.removeEventListener('keydown', this.keyDownHandler);
		this.outInput = null;
	}

	componentDidMount() {
		this.getDefaultTime(this.props);
		this.outInput = this.select && this.select.querySelector('input');
		this.outInput.addEventListener('keydown', this.keyDownHandler);
	}

	componentWillReceiveProps(nextProps) {
		this.getDefaultTime(nextProps);
	}

	openCallBack(flag) {
		this.props.open = flag;
		this.setState(this.state);
	}

	onClick = (e, datepicker) => {
		let datepickerObj = this.datepickerWrap ? this.datepickerWrap.dateInput : datepicker;
		let datepickerDom = ReactDOM.findDOMNode(datepickerObj);
		// console.log(e, datepickerDom, datepicker, ReactDOM.findDOMNode(this));
		// tab 触发时出现找不到 ref this.datepickerWrap 情况 mddify -- qinbb  // 猜测为子级组件调用是在setState回调中  但是组件对象还没有挂载到ref
		this.props.onClick && this.props.onClick(datepickerDom || this.select.querySelector('.nc-input'));
	};

	/**
	 * 添加一个关闭时  调用 onBlur事件 bbqin
	 * config {object}
	 */
	onOpenChangeInTable = (isOpen, val, formatValue, config) => {
		const { onBlur, value, onOpenChange, tableOpen } = this.props;

		//目前按ctrl键 会触发表格onBlur事件因此在这儿加一个控制，如果是ctrl|esc触发关闭不去调用表格的blur事件
		if (!isOpen && tableOpen && config && (config.ctrlKeyDown !== true && config.escKeyDown !== true)) {
			typeof onBlur === 'function' && onBlur(value);
		}
		onOpenChange && onOpenChange(isOpen, val, formatValue);
	};

	close = e => {
		const { onBlur, value } = this.props;
		// 当在面板里的时候做下判断 -- by bbqin
		let picerPanel = document.querySelector('.rc-calendar.nc-input');
		// 判断当前组件是否被聚焦 有两种情况  情况一 面板弹开  情况二  input 聚焦
		let inputDom = this.select.querySelector('input');
		let focused = document.activeElement === inputDom || this.opened;
		if (
			focused &&
			this.select &&
			!this.select.contains(e.target) &&
			!(picerPanel && picerPanel.contains(e.target))
		) {
			this.opened = false;
			typeof onBlur === 'function' && onBlur(value);
		}
	};

	/*
	* 获取到外面传进来的默认时间然后将默认时间从东八区（北京时间）转为当地时区的函数
	* props 包含  {
	*    isRangDay： 布尔值， // 用来判断是时间还是时段，时段为true
	*    value: moment 对象 （参考moment.js）
	* }
	*
	* */
	getDefaultTime = props => {
		let { isRangDay, value, notconverttimezones } = props;
		let BeijinVal = value;
		if (isRangDay) BeijinVal = value ? value.split('_') && value.split('_')[0] : value;
		BeijinVal = BeijinVal ? (typeof BeijinVal == 'string' ? BeijinVal.trim() : BeijinVal) : BeijinVal;
		let currentVal = BeijinVal || null;
		if (BeijinVal) {
			if (!timeFunctionHandler(BeijinVal)) {
				if (this.timeMomentHandler(BeijinVal)) {
					currentVal = !localeZoneIsDongba ? DongbaToLocalTime(BeijinVal, notconverttimezones) : BeijinVal;
				} else {
					currentVal = !localeZoneIsDongba ? DongbaToLocalTime(moment(BeijinVal), notconverttimezones) : moment(BeijinVal);
				}
			}
		}
		this.setState({
			current: currentVal || null,
			timeFun: currentVal,
		});
	};

	/*
	* 计算rangeDay的changeTime
	*
	*
	*
	* */
	rangDayChangeTime = (v, tag, flag) => {
		let { onChange, onSelect, needTime, onOpenChange } = this.props,
			BeijinValStart = null,
			BeijinValEnd = null;
		// 东八区的时间 转为本地时间
		if (v) {
			let date = v.format('YYYY-MM-DD');
			let hhmmss1 = '00:00:00';
			let hhmmss2 = '23:59:59';
			BeijinValStart = !localeZoneIsDongba
				? LocalToDongbaTime(moment(`${date} ${hhmmss1}`), this.props.notconverttimezones)
				: moment(`${date} ${hhmmss1}`);
			BeijinValEnd = !localeZoneIsDongba
				? LocalToDongbaTime(moment(`${date} ${hhmmss2}`), this.props.notconverttimezones)
				: moment(`${date} ${hhmmss2}`);
		}
		let currentRangeDay = BeijinValStart
			? `${BeijinValStart.format('YYYY-MM-DD HH:mm:ss')}_${BeijinValEnd.format('YYYY-MM-DD HH:mm:ss')}`
			: null;
		tag === 'onChange' && onChange && onChange(currentRangeDay);
		tag === 'onSelect' && onSelect && onSelect(currentRangeDay);
		tag === 'onOpenChange' &&
			onOpenChange &&
			onOpenChange(
				flag,
				currentRangeDay,
				v ? (needTime ? v.format('YYYY-MM-DD HH:mm:ss') : v.format('YYYY-MM-DD')) : null,
			);
	};

	/*
	* 接受日历选中的本地时区的时间，然后转成东八区时间，调用tag传过来的回调函数对应的props中的回调函数
	* value: 本地时间
	* tag: String, // 回调函数名
	* flag： 布尔值，//onOpenChange的时候日历展开状态
	*
	* */
	changeTime = ({ value, tag, flag }) => {
		/*
		* HHmmss: 判断是开始日期组件还是结束日期组件 （开始为00:00:00、结束为23:59:59）
		* needTime:
		*
		* */
		let { HHmmss, needTime, isClientTime, isRangDay, needNowTime, onChange, onSelect, onOpenChange } = this.props,
			BeijinVal = null;
		//如果是时间函数的onchange 直接返回函数 xuyangt
		if (timeFunctionHandler(value) && tag === 'onChange') {
			onChange && onChange(value, getFuntionValue(value));
			return;
		}

		if (isRangDay) {
			this.rangDayChangeTime(value, tag, flag);
		} else {
			if (value && moment.isMoment(value)) {
				let date = value.format('YYYY-MM-DD');
				let hhmmss = needTime ? (needNowTime ? moment().format('HH:mm:ss') : HHmmss) : null;
				isClientTime ? (hhmmss = value.format('HH:mm:ss')) : hhmmss;
				BeijinVal = !localeZoneIsDongba
					? LocalToDongbaTime(moment(hhmmss ? `${date} ${hhmmss}` : date), this.props.notconverttimezones)
					: moment(hhmmss ? `${date} ${hhmmss}` : date);
				let result = BeijinVal
					? needTime ? BeijinVal.format('YYYY-MM-DD HH:mm:ss') : BeijinVal.format('YYYY-MM-DD')
					: null;
				tag === 'onChange' &&
					onChange &&
					onChange(
						result,
						value ? (needTime ? value.format('YYYY-MM-DD HH:mm:ss') : value.format('YYYY-MM-DD')) : null,
					);
				tag === 'onSelect' &&
					onSelect &&
					onSelect(
						result,
						value ? (needTime ? value.format('YYYY-MM-DD HH:mm:ss') : value.format('YYYY-MM-DD')) : null,
					);
				tag === 'onOpenChange' &&
					onOpenChange &&
					onOpenChange(
						flag,
						result,
						value ? (needTime ? value.format('YYYY-MM-DD HH:mm:ss') : value.format('YYYY-MM-DD')) : null,
					);
			} else {
				if (tag === 'onChange') {
					onChange && onChange(value);
				}
				if (tag === 'onSelect') {
					onSelect && onSelect(value);
				}
				if (tag === 'onOpenChange') {
					onOpenChange && onOpenChange(flag);
				}
			}
		}
	};

	/*
	* 日期组件value变化的时候会触发
	* v: value   Moment对象
	* */
	onChange = v => {
		this.setState({ timeFun: v });
		this.props.onChange && this.changeTime({ value: v, tag: 'onChange' });
	};

	/*
	* 选择日历的某个数字就会触发
	* v: value  Moment对象
	* */
	onSelect = v => {
		this.props.onSelect && this.changeTime({ value: v, tag: 'onSelect' });
	};

	/*
	* 日历弹出及隐藏的时候会触发
	* flag: 布尔值，//日历弹出为true 隐藏为false
	* momentValue： Moment对象
	* dateValue: 待探索
	* */
	onOpenChange = (flag, momentValue) => {
		let { onClose } = this.props;
		!flag && typeof onClose === 'function' && onClose(momentValue)
		this.props.onOpenChange && this.changeTime({ value: momentValue, tag: 'onOpenChange', flag });
		this.opened = flag;

		if (flag === false && this.outInput) {
			isIE() ? setElementFocusInIE(this.outInput) : this.outInput.focus();
		}
	};

	onFunctionSelected = () => {
		this.opened = false;
	};

	// 用来判断和处理时间函数
	timeMomentHandler = val => {
		let result = false;
		/*if (isArray(val)) {
			val.forEach(item => {
				if (typeof item === 'string' && item.indexOf('#') !== -1) {
					result = true;
				}
				result && list.push(item);
			})

		}*/
		result = Object.prototype.toString.call(val) === '[object Object]';
		return result;
	};

	keyDownHandler = e => {
		let { onEnter, renderInTable, onBlur } = this.props;
		if (e.keyCode === 13 && this.open !== true) {
			e.stopPropagation();
			e.preventDefault();
			onEnter && onEnter({ e, itemType: 'datePicker' });
			renderInTable && onBlur && onBlur();
		}
	};

	render() {
		let {
			format = 'YYYY-MM-DD',
			showStar,
			className,
			placeholder,
			onOpenChange,
			onChange,
			onSelect,
			showTimeFunction,
			showClear,
			disabled,
			tableOpen,
			...others
		} = this.props;
		let { current } = this.state;
		let functionValue = current || [];
		if (!current) {
			current = null;
		} else if (timeFunctionHandler(current)) {
			current = '';
			placeholder = ' ';
		}

		return (
			<div
				className={`u-form-control-wrapper ${className}`}
				onClick={e => {
					e.stopPropagation();
				}}
				ref={dom => {
					this.select = dom;
				}}
			>
				{showStar ? <span className="datepicker-input-required-tag">*</span> : ''}
				<div style={{ position: 'relative' }}>
					<DatePicker
						{...others}
						ref={datepicker => {
							this.datepickerWrap = datepicker; // 获取到组件对象 -- bbqin
						}}
						className={`${className} DatePickerTimeZoneConversion nc-input`}
						format={format}
						showClear={showClear}
						MultiTZ={true}
						// open={open||false}
						value={current}
						placeholder={placeholder}
						// disabledDate={(current, next) => {
						//     this.props.disabledDate && this.props.disabledDate(current, next, moment);
						// }}
						onOpenChange={tableOpen ? this.onOpenChangeInTable : this.onOpenChange}
						tableOpen={tableOpen}
						onChange={this.onChange}
						onSelect={this.onSelect}
						disabled={this.props.disabled}
						isFun={showTimeFunction}
						timeFun={this.state.timeFun}
						visible={true}
						renderFooter={() => {
							return (
								<div>
									{getDateFunNode(functionValue, this.onChange, showTimeFunction, this.props.hiddenFunList, this.props.notconverttimezones)}
									{this.props.renderFooter ? this.props.renderFooter() : null}
								</div>
							);
						}}
					/>
					{getTimeFunctionLabel(functionValue, showTimeFunction, this.openCallBack.bind(this))}
				</div>
			</div>
		);
	}
}

DatePickerClientS.defaultProps = {
	disabled: false,
	showToday: false,
	showClear: true,
	needTime: true,
	renderIcon: () => {
		return <i className="icon iconfont">&#xe6cd;</i>;
	},
};
DatePickerClientS.RangePicker = RangePicker;
export default DatePickerClientS;
